import React, { useEffect, useState} from 'react';
import { Card, Row, Col, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from '../../../config/axiosInstance';
import API_BASE_URL from '../../../config/api';

const NewsFeedPage = () => {
const navigate = useNavigate();
const [newsList, setNewsList] = useState([]);

const fetchNews = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/news`);
    setNewsList(res.data);
  } catch {
    message.error('โหลดข่าวล้มเหลว');
  }
};

useEffect(() => {
  fetchNews();
}, []);

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>ข่าวสาร</h1>
      <Row gutter={[24, 24]}>
        {newsList.map((news) => (
          <Col xs={24} sm={12} md={8} key={news.id}>
            <Card
              hoverable
              cover={
                <img
                  alt={news.title}
                  src={news.cover_image}
                  style={{ height: 450, objectFit: 'cover' }}
                />
              }
              onClick={()=>{navigate('/news/'+news.id)}}
            >
              <Card.Meta
                title={news.title}
                description={
                  <>
                    <p style={{ marginTop: 10 }}>{news.description}</p>
                    <Button type="primary" size="small" style={{ marginTop: 10 }} onClick={()=>{navigate('/news/'+news.id)}}>
                      อ่านเพิ่มเติม
                    </Button>
                  </>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default NewsFeedPage;
